<template>
  <div class="is-marginless is-paddingless section section-details">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('createUtilisateur.title') }}</h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button btn-modal-annuler is-cancel"
                    @click="$router.push({name: 'l.parametrage.collaborateurs' })">
              {{ $t('createUtilisateur.actions.cancel') }}
            </button>
            <button v-if="step !== 0" class="button is-addOrEdit"
                    @click="previousStep()">
              {{ $t('createUtilisateur.actions.etapePrecedente') }}
            </button>
            <button v-if="step !== 3" class="button is-addOrEdit"
                    @click="nextStep()">
              {{ $t('createUtilisateur.actions.etapeSuivante') }}
            </button>
            <button v-if="step === 3" class="button is-addOrEdit"
                    @click="saveUtilisateur()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                            :error="error"
                            :messagesChampsVide="messagesChampsVide"
                            :champsVide="champsVide"
                            :title="'editionClient.problemOccurred'"
                            :withEmplyFields="true"
                            @close="error = $event"/>
    </div>
    <div class="columns">
      <div class="column is-10">
        <keep-alive>
          <component :is="activeStep" :infoUser="utilisateur" :isAdd="true"
                     :societesAgence="societesAgence"
                     :utilisateur="utilisateur"
                     @editAgenceRattachement="editAgenceRattachement()"/>
        </keep-alive>
      </div>
      <div class="column is-2 steps-utilisateur">
        <app-steps :steps="steps" :actualStep="step"></app-steps>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import AppInfoUtilisateur from '@/components/parametrage/utilisateur/firstStepInformationsUtilisateur';
import AppSocieteAgence from '@/components/parametrage/utilisateur/secondStepInformationsUtilisateur';
import AppRole from '@/components/parametrage/utilisateur/thirdStepInformationsUtilisateur';
import AppSteps from '@/components/general/steps';
import genererUtilisateur from '@/services/parametrage/generation/genererUtilisateur';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/parametrage/validation/validationModificationUtilisateur';
import { create } from '@/api/utilisateur/index';
import intToGuid from '@/services/general/transformIntToGuid';
import { getAllSocietesAgences } from '@/services/societe/getSocieteAgence';
import { getNewAgenceRattachement } from '@/services/societe/getAgenceRattachement';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import ServiceUtilisateur from '@/components/parametrage/utilisateur/serviceUtilisateur';

const Attachments = createNamespacedHelpers('attachments');

export default {
  components: {
    AppBreadcrumb,
    AppInfoUtilisateur,
    AppSocieteAgence,
    AppSteps,
    AppRole,
    errorMsgComponent,
    ServiceUtilisateur,
  },
  data() {
    return {
      messages: [],
      societesAgence: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      utilisateur: genererUtilisateur(),
      step: 0,
      activeStep: 'AppInfoUtilisateur',
      steps: [
        {
          title: this.$i18n.t('createUtilisateur.steps.first.title'),
          sousTitle: this.$i18n.t('createUtilisateur.steps.first.sousTitle'),
          step: 1,
        },
        {
          title: this.$i18n.t('createUtilisateur.steps.second.title'),
          sousTitle: this.$i18n.t('createUtilisateur.steps.second.sousTitle'),
          step: 2,
        },
        {
          title: this.$i18n.t('createUtilisateur.steps.third.title'),
          sousTitle: this.$i18n.t('createUtilisateur.steps.third.sousTitle'),
          step: 3,
        },
        {
          title: this.$i18n.t('createUtilisateur.steps.fourth.title'),
          sousTitle: this.$i18n.t('createUtilisateur.steps.fourth.sousTitle'),
          step: 4,
        },
      ],
    };
  },
  computed: {
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('createUtilisateur.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('createUtilisateur.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$i18n.t('createUtilisateur.listeCollaborateur'), route: { name: 'l.parametrage.collaborateurs' }, isActive: false },
        { title: this.$i18n.t('createUtilisateur.title'), route: { name: 'm.parametrage.collaborateurs-add' }, isActive: true },
      ];
      return output;
    },
  },
  methods: {
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    editAgenceRattachement() {
      getNewAgenceRattachement(this.utilisateur.agenceId, this.societesAgence,
        this.utilisateur.agencesId);
    },
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
    }),
    nextStep() {
      const steps = [
        { step: 1, activeStep: 'AppSocieteAgence' },
        { step: 2, activeStep: 'AppRole' },
        { step: 3, activeStep: 'ServiceUtilisateur' },
      ];

      const next = steps.find(s => s.step === this.step + 1);
      if (next) {
        this.step = next.step;
        this.activeStep = next.activeStep;
      }
    },
    previousStep() {
      const steps = [
        { step: 0, activeStep: 'AppInfoUtilisateur' },
        { step: 1, activeStep: 'AppSocieteAgence' },
        { step: 2, activeStep: 'AppRole' },
      ];

      const prev = steps.find(s => s.step === this.step - 1);
      if (prev) {
        this.step = prev.step;
        this.activeStep = prev.activeStep;
      }
    },
    async saveUtilisateur() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.utilisateur.roles = [];
        this.utilisateur.objetsRoles.forEach((role) => {
          this.utilisateur.roles.push(role.normalizedName);
        });
        if (this.utilisateur.motPasse.length > 0
          && this.utilisateur.motPasse !== this.utilisateur.motPasseConf) {
          throw new Error('MOT_PASSE_DIFFERENT');
        }
        const utilisateur = (await create(this.utilisateur)).data.result;
        await this.setAttachmentElementId({ id: intToGuid(utilisateur.id) });
        await this.insertAttachments(intToGuid(utilisateur.id));
        messageSucces(this.$t('createUtilisateur.ajoutSuccess'));
        await this.$router.push({ name: 'c.parametrage.collaborateurs', params: { id: utilisateur.id } });
        return loadingComponent.close();
      } catch (e) {
        if ((e.response && e.response.data.error) || e.message) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, e.message, this.champsVide, this.messages,
            this.messagesChampsVide);
          this.error = true;
          return loadingComponent.close();
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Utilisateur' });
      this.societesAgence = await getAllSocietesAgences(
        this.utilisateur.agenceId, this.utilisateur.agencesId,
      );
      this.setInformationPage(this.$t('pageParametrage.collaborateurs.creation'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
    }
  },
};
</script>
